import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOffersDuplicateMutation = createMutationHook(OffersApiClient.duplicateOffer, {
  mutationKey: ['duplicateOffer'],
})
